package com.cybersoftsolution.cybersoftsolutionweb.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.api.authenticate
import com.cybersoftsolution.cybersoftsolutionweb.components.dialogs.ProfileDialog
import com.cybersoftsolution.cybersoftsolutionweb.components.dialogs.SignInDialog
import com.cybersoftsolution.cybersoftsolutionweb.components.dialogs.SignUpDialog
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastContainer
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastMessage
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastStyle
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.showMyToast
import com.cybersoftsolution.cybersoftsolutionweb.models.AuthResponse
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.models.UserInfo
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.AUTH_LOGIN_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.AUTH_PARAM_NAME
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.CLIENT_ROOT_URI_PARAM_NAME
import com.cybersoftsolution.cybersoftsolutionweb.models.decodeFromBase64
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.ToastMessage
import com.cybersoftsolution.cybersoftsolutionweb.navigation.Screen
import com.cybersoftsolution.cybersoftsolutionweb.navigation.navigateTo
import com.cybersoftsolution.cybersoftsolutionweb.navigation.redirectTo
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.headerSectionHeight
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.toastBasicID
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.getUserEmailIfRemembered
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.getUserInfo
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.logout
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.rememberLogin
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px


enum class DialogType {
    None,
    SignIn,
    SignUp,
    ForgotPassword,
    Profile,
}
data class DisplayDialog(
    val type: DialogType,
    val userInfo: UserInfo?
)
@Composable
inline fun RootPageLayout(
    displayDialog : DisplayDialog = DisplayDialog(DialogType.None,null),
    incomeToastMessage: ToastMessage = ToastMessage(),
    crossinline onDismiss:() -> Unit = {},
    crossinline onLogout:()->Unit = {},
    crossinline onLogin:(success:Boolean, message:String?) -> Unit,
    crossinline onRegister:(success:Boolean, message:String?) -> Unit,
    crossinline onRestorePassword:(success:Boolean, message:String?) -> Unit,
    crossinline showSignUpDialog:()->Unit = {},
    crossinline showSignInDialog:()->Unit = {},
    crossinline showProfileDialog:()->Unit = {},
    crossinline content: @Composable () -> Unit
){

    var toastMessage by remember { mutableStateOf(incomeToastMessage) }

    LaunchedEffect(incomeToastMessage) {
        toastMessage = incomeToastMessage
    }

    val breakpoint = rememberBreakpoint()
    val scope = rememberCoroutineScope()
    val context = rememberPageContext()

    var userEmail:String by remember { mutableStateOf( getUserEmailIfRemembered() )  }
    var newUserEmail:String by remember { mutableStateOf( "" )  }
    var userName:String by remember { mutableStateOf( "" )  }
    var captchaVerified by remember { mutableStateOf(false) }
    var otpCode:String? by remember { mutableStateOf( null )  }
    var password by remember { mutableStateOf("") }
    var newPassword:String? by remember { mutableStateOf(null) }
    var confirmNewPassword:String? by remember { mutableStateOf(null) }
    var errorText by remember { mutableStateOf(" ") }
    var scaleAnimation by remember { mutableStateOf(false) }
    var scaleAnimationValue by remember { mutableStateOf(1.0) }
    LaunchedEffect(scaleAnimation) {
        scope.launch {
            scaleAnimationValue = 1.05
            delay(100)
            scaleAnimationValue = 1.0
        }

    }
    val animationModifier = Modifier
        .onClick {
            //Prevent capture the same click from the father element
            it.stopImmediatePropagation()
//                                  it.stopPropagation()
        }
        .scale(scaleAnimationValue) // Scale Animation Effect


    val json = Json {
        ignoreUnknownKeys = true
    }

//    console.info("context: ${context.route}")

    //Capturar los parametros de respuesta de authenticacion de la url y almacenar
    val authResponseFromParam: AuthResponse? by mutableStateOf(
        context.route.params[AUTH_PARAM_NAME]?.let { paramRespose ->
            paramRespose.decodeFromBase64()?.let { json.decodeFromString<AuthResponse?>(it) }
        }
    )

//    console.info("authResponse: $authResponse")


    LaunchedEffect(breakpoint) {
        console.log("userAgent: ${window.navigator.userAgent}")
    }

    LaunchedEffect(Unit) {

        window.onload = {

            authResponseFromParam?.let { response ->

                //Incoming Authentication Response from param
                if (response.success == true) {
                    scope.launch {

                        rememberLogin(
                            remember = null,
                            userId = authResponseFromParam?.userInfo?.id,
                            authorizationToken = authResponseFromParam?.userInfo?.authorizationToken,
                            userName = authResponseFromParam?.userInfo?.name,
                            userEmail = authResponseFromParam?.userInfo?.email,
                            userEmailVerified = authResponseFromParam?.userInfo?.emailVerified,
                            userPhone = authResponseFromParam?.userInfo?.phone,
                            userPicture = authResponseFromParam?.userInfo?.picture,
                        )
                        toastMessage = ToastMessage(message = "Sesión Iniciada satisfactoriamente", style = MyToastStyle.Success)
                    }
                    context.navigateTo(Screen.Root)
                } else {

                    response.errorMessage?.let {
                        toastMessage =  when (it) {
                            "User is not enable" -> ToastMessage(message = "Su cuenta esta deshabilitada temporalmente", style = MyToastStyle.Danger)
                            "Sign up failed" -> ToastMessage(message = "Fallo la autentificacion, intentelo mas tarde", style = MyToastStyle.Danger)
                            else -> ToastMessage(message = it, style = MyToastStyle.Danger)
                        }

                    }
                    //handle error auth
                    context.navigateTo(Screen.Root)
                }

            }?:(
                //Try to authenticate when Incoming Authentication Response is null and get user data
                scope.launch {
                    val userInfo = getUserInfo()
                    val userId = userInfo.id
                    val authorizationToken = userInfo.authorizationToken
                    var isAuthenticated = false
                    if (!userId.isNullOrEmpty() && !authorizationToken.isNullOrEmpty()) {
                        val authResponseFromApi = authenticate(userId, authorizationToken)
                        isAuthenticated = authResponseFromApi?.success == true
                        rememberLogin(
                            remember = null,
                            userId = authResponseFromApi?.userInfo?.id,
                            authorizationToken = authResponseFromApi?.userInfo?.authorizationToken,
                            userName = authResponseFromApi?.userInfo?.name,
                            userEmail = authResponseFromApi?.userInfo?.email,
                            userEmailVerified = authResponseFromApi?.userInfo?.emailVerified,
                            userPhone = authResponseFromApi?.userInfo?.phone,
                            userPicture = authResponseFromApi?.userInfo?.picture,
                        )

                        if (isAuthenticated) {
//                            toastMessage = ToastMessage(message = "Sesión reanudada", style = MyToastStyle.Info)
                        } else {
                            logout()
                            toastMessage = ToastMessage(message = "La sesión ha expirado", style = MyToastStyle.Warning)
                        }
                    }

                }



            )

        }

    }


    Box(
        Modifier
            .fillMaxSize(),
        contentAlignment = Alignment.TopStart
    ) {


        /*
            IsAuthenticatedLayout(delay = 1000L, asAdmin = true) {
        LoadingIndicator()
    }
         */

//        IsAuthenticatedLayout(delay = 0L, asAdmin = false) {
            content()
//        }


        if (displayDialog.type != DialogType.None) {
            Column(
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = if (breakpoint<= Breakpoint.SM)  Alignment.CenterHorizontally else Alignment.End,
                modifier = Modifier
                    .position(Position.Fixed)
                    .fillMaxSize()
                    .zIndex(70)
                    .padding(top = headerSectionHeight, right =if (breakpoint<= Breakpoint.SM) 0.px else (headerSectionHeight.value/2).toInt().px )
                    .backgroundColor(Theme.HalfBlack.rgb)
                    .onClick {
                        scaleAnimation = !scaleAnimation
                    }
            ) {
                when (displayDialog.type) {
                    DialogType.None -> {
                        onDismiss()
                    }
                    DialogType.SignIn -> {
                        SignInDialog(
                            rootModifier = animationModifier, // Scale Animation Effect
                            breakpoint = breakpoint,
                            scope = scope,
                            context = context,
                            userName = userEmail,
                            password = password,
                            setUsername = {userEmail = it},
                            setPassword = {password = it},
                            errorText = errorText,
                            otpCode = otpCode,
                            newPassword = newPassword,
                            confirmNewPassword = confirmNewPassword,
                            setNewPassword = {newPassword = it},
                            setConfirmNewPassword = {confirmNewPassword = it},
                            setErrorText = {errorText = it},
                            setOtpCode = {otpCode = it},
                            captchaVerified = captchaVerified,
                            setCaptchaVerified = {captchaVerified = it},
                            onClose = { onDismiss() },
                            onGoogleAuthButtonClick = {
                                onDismiss()
//                                context.redirectTo(AUTH_LOGIN_ROUTE)
                                context.redirectTo(
                                    apiRoute = AUTH_LOGIN_ROUTE,
                                    params = mutableMapOf(Pair(CLIENT_ROOT_URI_PARAM_NAME,context.route.origin))
                                )
                            },
                            onLoginSuccess = { successMessage ->
                                onLogin(true,successMessage)
//                                context.redirectTo("/")
                            },
                            onLoginFail = { errorMessage ->
                                onLogin(false,errorMessage)
                            },
                            onSignUpButtonClick = {
                                showSignUpDialog()
                            },
                            onRestorePasswordFail = { errorMessage ->
                                onRestorePassword(false,errorMessage)
                            },
                            onRestorePasswordSuccess = { successMessage ->
                                onRestorePassword(true,successMessage)
                            },
                            onRestorePasswordComplete = {
                                captchaVerified = false
                                otpCode = null
                                showProfileDialog()
                            }

                        )
                    }
                    DialogType.SignUp -> {
                        SignUpDialog(
                            rootModifier = animationModifier, // Scale Animation Effect
                            breakpoint = breakpoint,
                            scope = scope,
                            context = context,
                            userName = userName,
                            userEmail = newUserEmail,
                            otpCode = otpCode,
                            newPassword = newPassword,
                            confirmNewPassword = confirmNewPassword,
                            captchaVerified = captchaVerified,
                            setCaptchaVerified = {captchaVerified = it},
                            setEmail = {newUserEmail = it},
                            setUserName = {userName = it},
                            setOtpCode = {otpCode = it},
                            setNewPassword = {newPassword = it},
                            setConfirmNewPassword = {confirmNewPassword = it},
                            errorText = errorText,
                            setErrorText = {errorText = it},
                            onClose = { onDismiss() },
                            onGoogleAuthButtonClick = {
                                onDismiss()
//                                context.redirectTo(AUTH_LOGIN_ROUTE)
                                context.redirectTo(
                                    apiRoute = AUTH_LOGIN_ROUTE,
                                    params = mutableMapOf(Pair(CLIENT_ROOT_URI_PARAM_NAME,context.route.origin))
                                )
                            },
                            onRegisterSuccess = { successMessage ->
                                onRegister(true,successMessage)
//                                context.redirectTo("/")
                            },
                            onRegisterFail = { errorMessage ->
                                onRegister(false,errorMessage)
                            },
                            onSignInButtonClick = {
                                showSignInDialog()
                            },
                            onRegisterComplete = {
                                captchaVerified = false
                                otpCode = null
                                showProfileDialog()
                            }
                        )

                    }
                    DialogType.ForgotPassword -> {

                    }
                    DialogType.Profile -> {

                        displayDialog.userInfo?.let {
                            ProfileDialog(
                                rootModifier = animationModifier, // Scale Animation Effect
                                breakpoint = breakpoint,
                                scope = scope,
                                context = context,
                                userInfo = it,
                                onClose = { onDismiss() },
                                onLogoutButtonClick = {
                                    onLogout()
                                },
                                errorText = errorText,
                                setErrorText = {errorText = it},
                                otpCode = otpCode,
                                newPassword = newPassword,
                                confirmNewPassword = confirmNewPassword,
                                captchaVerified = captchaVerified,
                                setCaptchaVerified = {captchaVerified = it},
                                setOtpCode = {otpCode = it},
                                setNewPassword = {newPassword = it},
                                setConfirmNewPassword = {confirmNewPassword = it},
                                onRestorePasswordFail = { errorMessage ->
                                    onRestorePassword(false,errorMessage)
                                },
                                onRestorePasswordSuccess = { successMessage ->
                                    onRestorePassword(true,successMessage)
                                },
                                onRestorePasswordComplete = {
                                    captchaVerified = false
                                    otpCode = null
                                    newPassword = null
                                    confirmNewPassword = null

//                                    showProfileDialog()
                                }
                            )

                        }?: {onDismiss()}



                    }
                }



            }
        }


        var message by remember { mutableStateOf("") }

        MyToastContainer{
//            if (toastMessage.message.trim().isNotEmpty()){

            LaunchedEffect(toastMessage) {
                if (toastMessage.message.trim().isNotEmpty()) {
                    message = toastMessage.message
                }
            }

                MyToastMessage(
                    id = toastBasicID,
                    message = message, //toastMessage.message,
                    style = toastMessage.style,
                    border = 1,
                    onCloseClick = {
                        message = ""
                    }
                )
//            }
        }
        LaunchedEffect(toastMessage){
            if (toastMessage.message.trim().isNotEmpty()){
                scope.showMyToast(toastBasicID)
            }

        }

    }



}



